/** Connected Services registry — Gmail is Phase 1. */

export const SERVICE_GMAIL = "gmail";

export const CONNECTED_SERVICE_IDS = Object.freeze({
  GMAIL: SERVICE_GMAIL,
});

/**
 * @typedef {object} ConnectedServiceDefinition
 * @property {string} id
 * @property {string} label
 * @property {string} description
 */

/** @type {ConnectedServiceDefinition[]} */
export const CONNECTED_SERVICE_CATALOG = [
  {
    id: SERVICE_GMAIL,
    label: "Gmail",
    description: "Let Ashley summarize recent emails and open your inbox.",
  },
];

export function getConnectedServiceDefinition(serviceId) {
  return CONNECTED_SERVICE_CATALOG.find((s) => s.id === serviceId) || null;
}
